document.querySelectorAll('a[href^="#section-"]').forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();

    // Extract X from href="#section-X"
    const match = link.getAttribute('href').match(/#section-(\d+)/);
    if (!match) return;

    const index = Number(match[1]);

    // Get main's child number X (1-based)
    const target = document.querySelector(`main > :nth-child(${index})`);

    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});